module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/readable-stream/duplex-browser.js
// module id = 570
// module chunks = 0 3 5